'use strict';

angular.module('otpp-feature-toggles').directive('otppFeatureToggle', function(featureToggles) {
  return {
    scope: {
      featureEnabled: '@',
      featureDisabled: '@'
    },
    restrict: 'AE',
    transclude: true,
    template: '<div ng-if="enabled" ng-transclude></div>',
    link: function(scope, elem, attrs) {
      attrs.$observe('featureEnabled', function(value) {
        scope.enabled = featureToggles.isEnabled(value);
      });

      attrs.$observe('featureDisabled', function(value) {
        scope.enabled = !featureToggles.isEnabled(value);
      });
    }
  };
});
